/**
 * BrewNectar The Evidence — accordion panels + scroll animations
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initScrollAnimations(section) {
    var animated = section.querySelectorAll('.bn-evidence__animate');

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      animated.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: '-60px 0px', threshold: 0 }
    );

    animated.forEach(function (el) {
      observer.observe(el);
    });
  }

  function closeAll(section) {
    section.querySelectorAll('[data-evidence-toggle]').forEach(function (btn) {
      btn.classList.remove('is-expanded');
      btn.setAttribute('aria-expanded', 'false');
    });

    section.querySelectorAll('[data-evidence-panel]').forEach(function (panel) {
      panel.classList.remove('is-active');
      panel.hidden = true;
    });
  }

  function openPanel(section, key) {
    var panel = section.querySelector('[data-evidence-panel="' + key + '"]');
    if (!panel) return;

    panel.hidden = false;
    panel.classList.add('is-active');
  }

  function initAccordion(section) {
    var toggles = section.querySelectorAll('[data-evidence-toggle]');

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-evidence-toggle');
        var isExpanded = btn.classList.contains('is-expanded');

        closeAll(section);

        if (!isExpanded) {
          btn.classList.add('is-expanded');
          btn.setAttribute('aria-expanded', 'true');
          openPanel(section, key);
        }
      });
    });
  }

  function initSection(section) {
    if (!section || section.dataset.bnEvidenceInit === 'true') return;
    section.dataset.bnEvidenceInit = 'true';

    initScrollAnimations(section);
    initAccordion(section);
  }

  function initAll() {
    document.querySelectorAll('[data-bn-evidence-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-bn-evidence-section]') || e.target;
    if (section.matches && section.matches('[data-bn-evidence-section]')) {
      section.dataset.bnEvidenceInit = '';
      initSection(section);
    }
  });
})();
